import type { EmployeeForStaffingCalendar } from './employee-for-staffing-calendar';

export const _sortEmployees = function (
  employees: EmployeeForStaffingCalendar[],
  treatmentProvidersFirst: boolean,
): EmployeeForStaffingCalendar[] {
  if (treatmentProvidersFirst) {
    const treatmentProviders = employees.filter(function (employee) {
      return employee.treatmentProvider;
    });
    const notTreatmentProviders = employees.filter(function (employee) {
      return !employee.treatmentProvider;
    });
    return treatmentProviders.concat(notTreatmentProviders);
  }
  return employees;
};
